import { render } from "./TheServiceItem.vue?vue&type=template&id=1a17368a&scoped=true&ts=true"
import script from "./TheServiceItem.vue?vue&type=script&lang=ts"
export * from "./TheServiceItem.vue?vue&type=script&lang=ts"

import "./TheServiceItem.vue?vue&type=style&index=0&id=1a17368a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lq\\Desktop\\普康\\activity-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a17368a"]])

export default __exports__